import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    defaultProps: {},
    styleOverrides: {
        root: {
            "&.global-navigation-flat": {
                " svg": {
                    opacity: 0.87,
                },
                " img": {
                    opacity: 0.87,
                },
            },
            "&.global-navigation-flat.active": {
                background: theme.palette.highlight.main,
                " svg": {
                    fill: theme.colors?.light || "#fafafa",
                    opacity: 1,
                },
                " img": {
                    color: theme.colors?.light || "#fafafa",
                    opacity: 1,
                },
            },
            "&.user-settings.global-navigation-flat.active": {
                background: theme.palette.highlight.main,
            },
            "&:hover": {
                " svg": {
                    fill: theme.colors?.light || "#fafafa",
                    opacity: 1,
                },
                " img": {
                    color: theme.colors?.light || "#fafafa",
                    opacity: 1,
                },
            },
        },
    },
})
